<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogNew',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-member-dialog'" :title="state.dialog.title"
    :width="'900px'" :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt" @ok="onSubmit"
    @cancel="closeDialog" :closable="false" :maskClosable="false">
    <a-spin :spinning="state.loading.dialogUpload">
      <a-form ref="formRef" :model="state.ruleForm" :rules="currentRules" :label-col="{ style: 'width: 100px' }"
        :wrapper-col="{ style: 'flex: 1' }">
        <!-- 基本信息标题 -->
        <a-row :gutter="24">
          <a-col :span="state.viewType === 'edit' ? 12 : 20">
            <div class="section-title">
              <div class="section-title-icon"></div>
              基本信息
            </div>
          </a-col>
          <a-col v-if="state.viewType === 'edit'" :span="12" class="text-right mb20">
            <a-button @click="resetPassword">重置密码</a-button>
          </a-col>
        </a-row>

        <!-- 人员ID | 角色 -->
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="人员ID" name="userNumber">
              <a-input v-model:value="state.ruleForm.userNumber" placeholder="请输入人员ID"
                :disabled="state.viewType !== 'add'" :maxlength="10" @change="onInputId" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="角色2" name="roleId">
              <a-select v-model:value="state.ruleForm.roleId" placeholder="请选择" allow-clear
                :disabled="state.viewType === 'detail'" @change="changeRole">
                <a-select-option v-for="item in props.roleList" :key="item.code" :value="item.code">{{ item.name
                  }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 姓名 | 手机号 -->
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="姓名" name="fullName">
              <a-input v-model:value="state.ruleForm.fullName" placeholder="请输入姓名"
                :disabled="state.viewType === 'detail'" :maxlength="10" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="手机号" name="tel">
              <a-input v-model:value="state.ruleForm.tel" placeholder="请输入手机号" :disabled="state.viewType === 'detail'"
                :maxlength="11" @change="onInputTel" />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 登录账号 -->
        <a-row v-if="state.viewType === 'edit' || state.viewType === 'detail'" :gutter="24">
          <a-col :span="12">
            <a-form-item label="登录账号" name="username">
              <a-input v-model:value="state.ruleForm.username" placeholder="请输入登录账号"
                :disabled="state.viewType === 'detail'" :maxlength="20" />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 附加信息 -->
        <template v-if="state.ruleForm.roleId">
          <a-row :gutter="24">
            <a-col :span="20">
              <div class="section-title">
                <div class="section-title-icon"></div>
                附加信息
              </div>
            </a-col>
          </a-row>

          <!-- 所属队站 | 岗位类型 -->
          <a-row v-if="permType === '2'" :gutter="24">
            <a-col :span="12">
              <a-form-item label="所属队站" name="siteId">
                <a-cascader v-model:value="cascaderValue" :options="props.areaMicroTree"
                  :field-names="{ value: 'id', label: 'label', children: 'children' }" placeholder="请选择区域" allow-clear
                  :disabled="state.viewType === 'detail'" @change="handleCascaderChange" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="岗位类型" name="postType">
                <a-select v-model:value="state.ruleForm.postType" placeholder="请选择" allow-clear
                  :disabled="state.viewType === 'detail'">
                  <a-select-option v-for="item in stateT.postTypeList" :key="item.code" :value="item.code">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 工号 | 身份证号 -->
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="工号" name="workNo">
                <a-input v-model:value="state.ruleForm.workNo" placeholder="请输入工号"
                  :disabled="state.viewType === 'detail'" :maxlength="10" @change="onInputWork" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="身份证号" name="documentCode">
                <a-input v-model:value="state.ruleForm.documentCode" placeholder="请输入身份证号"
                  :disabled="state.viewType === 'detail'" :maxlength="18" @change="onInputCard" />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 入职日期 | 性别 -->
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="入职日期" name="entryDate">
                <a-date-picker v-model:value="state.ruleForm.entryDate" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择" style="width: 100%" :disabled="state.viewType === 'detail'" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="性别" name="gender">
                <a-select v-model:value="state.ruleForm.gender" placeholder="请选择" allow-clear
                  :disabled="state.viewType === 'detail'">
                  <a-select-option value="1">男</a-select-option>
                  <a-select-option value="2">女</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 民族 | 籍贯 -->
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="民族" name="famousEthnicGroup">
                <a-input v-model:value="state.ruleForm.famousEthnicGroup" placeholder="请输入民族"
                  :disabled="state.viewType === 'detail'" :maxlength="10" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="籍贯" name="nativePlace">
                <a-input v-model:value="state.ruleForm.nativePlace" placeholder="请输入籍贯"
                  :disabled="state.viewType === 'detail'" :maxlength="10" />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 家庭住址 -->
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="家庭住址" name="addr">
                <a-input v-model:value="state.ruleForm.addr" placeholder="请输入家庭住址"
                  :disabled="state.viewType === 'detail'" :maxlength="100" />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 照片 | 岗前培训表 -->
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="照片" name="headUrl">
                <div v-if="state.viewType !== 'detail'">
                  <a-upload :action="uploadUrl" :headers="uploadHeaders" :show-upload-list="false"
                    :before-upload="beforeAvatarUploadHead" @change="handleHeadChange">
                    <div v-if="state.ruleForm.headUrl" class="avatar-preview">
                      <img :src="state.ruleForm.headUrl" alt="照片"
                        style="width: 100px; height: 100px; object-fit: cover; border-radius: 4px" />
                    </div>
                    <a-button v-else>
                      <UploadOutlined />上传照片
                    </a-button>
                  </a-upload>
                  <a-button v-if="state.ruleForm.headUrl" type="link" danger size="small"
                    @click="handleDelete('head')">删除</a-button>
                </div>
                <div v-else>
                  <img v-if="state.ruleForm.headUrl" :src="state.ruleForm.headUrl" alt="照片"
                    style="width: 100px; height: 100px; object-fit: cover; border-radius: 4px" />
                  <span v-else class="no-data">暂无照片</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="岗前培训表" name="trainSchedule">
                <div v-if="state.viewType !== 'detail'">
                  <a-upload :action="uploadUrl" :headers="uploadHeaders"
                    :data="{ biz: 'train_schedule', saveFlag: '1' }" :show-upload-list="false"
                    :before-upload="beforeAvatarUpload" @change="handleTrainChange">
                    <div v-if="state.ruleForm.trainSchedule" class="file-preview">
                      <a-button type="link" @click="handleDownload">{{ state.ruleForm.trainScheduleFileName || '查看培训表'
                        }}</a-button>
                    </div>
                    <a-button v-else>
                      <UploadOutlined />上传培训表
                    </a-button>
                  </a-upload>
                  <a-button v-if="state.ruleForm.trainSchedule" type="link" danger size="small"
                    @click="handleDelete('trainSchedule')">删除</a-button>
                </div>
                <div v-else>
                  <a-button v-if="state.ruleForm.trainSchedule" type="link" @click="handleDownload">{{
                    state.ruleForm.trainScheduleFileName || '查看培训表' }}</a-button>
                  <span v-else class="no-data">暂无岗前培训表</span>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
    </a-spin>

    <template #footer>
      <a-button @click="closeDialog">取消</a-button>
      <a-button v-if="state.viewType !== 'detail'" type="primary" class="ml10" :loading="state.loading.submit"
        @click="onSubmit">{{ state.dialog.submitTxt }}</a-button>
    </template>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogNew">
import { reactive, ref, onMounted, computed, nextTick, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash-es'
import { useMember } from '@/store/system/member'
const memberStore = useMember()
import { verifiyNumberInteger, verifyCnAndSpace, verifyEnglishAndNumber, verifyPhone, verifyIdCard } from '@/utils/toolsValidate'
import storage from '@/utils/Storage'
import { ACCESS_TOKEN } from '@/store/mutation-types'

interface RoleItem {
  code: string
  name: string
  permType: string
}

const props = defineProps<{
  roleList: RoleItem[]
  areaMicroTree: any[]
}>()

const emit = defineEmits(['refresh', 'createStaff', 'updateStaff', 'reasetPwd'])

const formRef = ref()
const cascaderValue = ref<string[]>([])
const permType = ref('')
const uploadUrl = import.meta.env.VITE_PROXY + '/api/base/uploadFile'
const uploadHeaders = computed(() => ({
  Authorization: storage.get(ACCESS_TOKEN) || ''
}))

const validateTel = (_rule: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入手机号'))
  }
  if (!verifyPhone(value)) {
    return Promise.reject(new Error('手机号格式不正确'))
  }
  return Promise.resolve()
}

const verifyIdDocumentCode = (_rule: any, value: string) => {
  const trimmedValue = value ? value.trim() : ''
  const isRequired = permType.value === '2'
  const isEmpty = !trimmedValue
  const isFormatValid = verifyIdCard(trimmedValue)

  if (isRequired) {
    if (isEmpty) {
      return Promise.reject(new Error('请输入身份证号'))
    }
    if (!isFormatValid) {
      return Promise.reject(new Error('身份证格式不正确'))
    }
  } else {
    if (!isEmpty && !isFormatValid) {
      return Promise.reject(new Error('身份证格式不正确'))
    }
  }
  return Promise.resolve()
}

const initRuleForm = {
  id: '',
  userNumber: '',
  roleId: '',
  roleName: '',
  fullName: '',
  tel: '',
  username: null as string | null,
  siteId: '',
  postType: '',
  workNo: '',
  documentCode: '',
  gender: '',
  entryDate: null,
  famousEthnicGroup: '',
  nativePlace: '',
  addr: '',
  headUrl: '',
  trainSchedule: '',
  trainScheduleFileName: ''
}

const state = reactive({
  dialog: {
    visible: false,
    title: '',
    submitTxt: ''
  },
  loading: {
    dialogUpload: false,
    submit: false
  },
  ruleForm: cloneDeep(initRuleForm),
  viewType: ''
})

const stateT = reactive({
  postTypeList: [] as any[]
})

const currentRules = computed(() => {
  const common = {
    userNumber: [{ required: true, message: '请输入人员ID', trigger: 'blur' }],
    fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
    username: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
    roleId: [{ required: true, message: '请选择角色类型', trigger: 'change' }],
    tel: [{ required: true, validator: validateTel, trigger: 'blur' }]
  }
  if (permType.value === '2') {
    return {
      ...common,
      siteId: [{ required: true, message: '请选择所属队站', trigger: 'change' }],
      postType: [{ required: true, message: '请选择岗位类型', trigger: 'change' }],
      workNo: [{ required: true, message: '请输入工号', trigger: 'blur' }],
      documentCode: [{ required: true, validator: verifyIdDocumentCode, trigger: 'blur' }],
      entryDate: [{ required: true, message: '请选择入职日期', trigger: 'change' }],
      gender: [{ required: true, message: '请选择性别', trigger: 'change' }]
    }
  }
  return {
    ...common,
    documentCode: [{ validator: verifyIdDocumentCode, trigger: 'blur' }]
  }
})

onMounted(async () => {
  const postType: any = await memberStore.getDict({ code: 'post_type' })
  stateT.postTypeList = postType || []
})

const findCascaderPath = (nodes: any[], targetId: string, path: string[] = []): string[] | null => {
  for (const node of nodes) {
    const currentPath = [...path, node.id]
    if (String(node.id) === String(targetId)) return currentPath
    if (node.children?.length) {
      const found = findCascaderPath(node.children, targetId, currentPath)
      if (found) return found
    }
  }
  return null
}

const openDialog = async (type: string, row?: any) => {
  state.viewType = type
  state.dialog.title = type === 'edit' ? '修改人员' : type === 'detail' ? '人员详情' : '新增人员'
  state.dialog.submitTxt = type === 'edit' ? '修改' : type === 'detail' ? '返回' : '新增'

  if (type === 'edit' || type === 'detail') {
    state.ruleForm = cloneDeep(row)
    state.ruleForm.siteId = state.ruleForm.siteId ? String(state.ruleForm.siteId) : ''
    state.ruleForm.postType = state.ruleForm.postType ? String(state.ruleForm.postType) : ''

    const matchedRole = props.roleList.find((item) => item.code == state.ruleForm.roleId || String(item.code) === String(state.ruleForm.roleId))
    if (matchedRole) {
      state.ruleForm.roleId = matchedRole.code
      permType.value = matchedRole.permType || ''
    } else {
      permType.value = ''
    }

    if (state.ruleForm.siteId && props.areaMicroTree.length) {
      const path = findCascaderPath(props.areaMicroTree, state.ruleForm.siteId)
      cascaderValue.value = path || []
    } else {
      cascaderValue.value = []
    }
  } else {
    state.ruleForm = cloneDeep(initRuleForm)
    permType.value = ''
    cascaderValue.value = []
  }

  state.dialog.visible = true
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

const closeDialog = () => {
  state.dialog.visible = false
  state.loading.submit = false
  state.ruleForm = cloneDeep(initRuleForm)
  cascaderValue.value = []
  permType.value = ''
  formRef.value?.clearValidate()
}

const handleCascaderChange = (value: string[]) => {
  cascaderValue.value = value || []
  state.ruleForm.siteId = value?.[value.length - 1] || ''
}

const onInputId = () => {
  state.ruleForm.userNumber = verifiyNumberInteger(state.ruleForm.userNumber)
}

const onInputTel = () => {
  state.ruleForm.tel = verifiyNumberInteger(state.ruleForm.tel)
}

const onInputWork = () => {
  state.ruleForm.workNo = verifyEnglishAndNumber(state.ruleForm.workNo)
}

const onInputCard = () => {
  state.ruleForm.documentCode = verifyCnAndSpace(state.ruleForm.documentCode)
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(() => {
      state.loading.submit = true
      if (state.viewType === 'add') {
        emit('createStaff', cloneDeep(state.ruleForm))
      } else if (state.viewType === 'edit') {
        emit('updateStaff', cloneDeep(state.ruleForm))
      } else {
        closeDialog()
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

const resetPassword = () => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: '重置密码，是否继续?',
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      emit('reasetPwd', state.ruleForm.id)
    }
  })
}

const changeRole = () => {
  const role = props.roleList.find((item) => item.code == state.ruleForm.roleId)
  permType.value = role?.permType || ''
}

const handleDownload = () => {
  if (state.ruleForm.trainSchedule) {
    window.open(state.ruleForm.trainSchedule, '_blank')
  }
}

const handleDelete = (type: string) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `确认删除${type === 'head' ? '照片' : '岗前培训表'}`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      if (type === 'head') {
        state.ruleForm.headUrl = ''
      } else {
        state.ruleForm.trainSchedule = ''
        state.ruleForm.trainScheduleFileName = ''
      }
    }
  })
}

const beforeAvatarUploadHead = (file: any) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    message.error('请上传图片格式文件')
    return false
  }
  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isLt10M) {
    message.error('图片大小不能超过10MB')
    return false
  }
  return true
}

const beforeAvatarUpload = (file: any) => {
  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isLt10M) {
    message.error('文件大小不能超过10MB')
    return false
  }
  return true
}

const handleHeadChange = (info: any) => {
  if (info.file.status === 'done') {
    const response = info.file.response
    if (response && response.code === 200 && response.data) {
      state.ruleForm.headUrl = response.data
      message.success('照片上传成功')
    } else {
      message.error(response?.msg || '照片上传失败')
    }
  } else if (info.file.status === 'error') {
    message.error('照片上传失败')
  }
}

const handleTrainChange = (info: any) => {
  if (info.file.status === 'done') {
    const response = info.file.response
    if (response && response.code === 200 && response.data) {
      state.ruleForm.trainSchedule = response.data.fileId || response.data
      state.ruleForm.trainScheduleFileName = info.file.name
      message.success('培训表上传成功')
    } else {
      message.error(response?.msg || '培训表上传失败')
    }
  } else if (info.file.status === 'error') {
    message.error('培训表上传失败')
  }
}

const stopSubmitLoading = () => {
  state.loading.submit = false
}

defineExpose({
  openDialog,
  closeDialog,
  stopSubmitLoading
})
</script>

<style scoped>
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.text-right {
  text-align: right;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.section-title-icon {
  width: 4px;
  height: 16px;
  background: #1890ff;
  margin-right: 8px;
  border-radius: 2px;
}

.avatar-preview {
  display: inline-block;
}

.file-preview {
  display: inline-block;
}

.no-data {
  color: #999;
}
</style>
